import { render, staticRenderFns } from "./pl-popover.vue?vue&type=template&id=6309dd48&"
import script from "./pl-popover.vue?vue&type=script&lang=js&"
export * from "./pl-popover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports